// extracted by mini-css-extract-plugin
export default {"Container":"ArticleItem_Container__tac6y","Body":"ArticleItem_Body__AlVpf","Info":"ArticleItem_Info__VQWqQ"};